module.exports = __webpack_public_path__ + "LC.png?5f0dc5abcb4894b08fef2d5904777f76";